import { AbstractFilterHandler } from '../AbstractFilterHandler';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';

export class EmptyElementsFilterHandler extends AbstractFilterHandler {
    public handle(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        // console.log('EmptyElementsFilterHandler->handle');

        const arr = JSON.parse(JSON.stringify(data)) as FilterData[];
        let res: FilterData[];

        if (filterOptions.showEmptyElements !== undefined && !filterOptions.showEmptyElements) {
            res = arr.filter((el: FilterData) => {
                if (el.x_lessons) {
                    return el.x_lessons.length > 0;
                } else {
                    return el.lessons.length > 0;
                }
            });
        } else {
            res = arr;
        }

        return super.handle(res, filterOptions);
    }
}
